// @ts-nocheck

import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { registerUser } from "../store/userSlice";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { useAppDispatch } from "../hooks/useRedux";
import { BASE_URL } from "../Constants/BaseUrl";

const CodeVerificationScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;
  const otpFromServer = location.state?.otp;

  const [code, setCode] = useState(new Array(6).fill(""));
  const [isInvalidCode, setIsInvalidCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [otp, setOtpFromServer] = useState(otpFromServer);
  const inputsRef = useRef([]);

  const handleChange = (element, index) => {
    const val = element.value;
    if (/[^0-9]/.test(val)) return;

    const newCode = [...code];
    newCode[index] = val;
    setCode(newCode);

    if (val && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmitCode = async () => {
    const fullCode = code.join("");

    if (fullCode.length !== 6) {
      toast.error("Please enter the 6-digit verification code.");
      return;
    }

    setLoading(true);
    if (fullCode.toString() !== otp?.toString()) {
      setLoading(false);
      setIsInvalidCode(true);
      toast.error("Invalid verification code. Please try again.");
      return;
    }

    setIsInvalidCode(false);

    try {
      const data = new FormData();
      data.append("email", email);
      data.append("secretKey", "OtpIsOkLetMeLogin!!!");

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${BASE_URL}auth/email-verified`,
        data,
      };

      const verifyEmailResponse = await axios.request(config);
      console.log(
        "Verify email response:",
        JSON.stringify(verifyEmailResponse.data, null, 2)
      );

      if (
        verifyEmailResponse?.data?.success &&
        verifyEmailResponse?.data?.profileCompleted === "no"
      ) {
        toast.success(
          "Email verification successful. Please complete your profile."
        );
        navigate("/complete-profile", {
          state: { student_athlete_id: location.state?.athlete_id },
        });
      } else {
        toast.error(
          verifyEmailResponse?.data?.message || "Email verification failed."
        );
      }
    } catch (error) {
      console.error("Verification error:", JSON.stringify(error, null, 2));

      let errorMessage = "An unexpected error occurred. Please try again.";
      if (error.response) {
        errorMessage = error.response?.data?.message || errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleResendApi = async () => {
    setResendLoading(true);

    try {
      const data = new FormData();
      data.append("email", email);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${BASE_URL}athlete/register-otp`,
        data,
      };

      const response = await axios.request(config);
      console.log("Resend Response:", response.data);

      if (response.data?.success) {
        setOtpFromServer(response.data.otp);
        toast.success("Verification code resent to your email.");
      } else {
        toast.error(
          response.data?.message || "Failed to resend verification email."
        );
      }
    } catch (error) {
      console.error("Resend error:", error);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white px-4 py-8">
      <ToastContainer />
      <div className="max-w-xl mx-auto">
        <div className="flex flex-col items-center mb-6">
          <img
            src={LOGO}
            alt="logo"
            className="h-40 w-40 object-contain mb-2"
          />
          <img src={APPNAME} alt="app name" className="h-14 object-contain" />
        </div>

        <h2 className="text-center text-lg font-semibold uppercase text-white mb-3">
          Enter Verification Code
        </h2>

        <p className="text-sm mb-6 text-center">
          We’ve sent a 6-digit verification code to your email. Please enter it
          below.
        </p>

        <div className="flex justify-center space-x-2 mb-6">
          {code.map((digit, idx) => (
            <input
              key={idx}
              type="text"
              maxLength="1"
              value={digit}
              ref={(el) => (inputsRef.current[idx] = el)}
              onChange={(e) => handleChange(e.target, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              className={`w-12 h-12 text-center text-xl rounded-md ${
                isInvalidCode ? "border-red-600" : "border-gray-600"
              } bg-[#2a2a2a] text-white border focus:ring-2 focus:ring-[#C00000] focus:outline-none`}
            />
          ))}
        </div>

        <button
          onClick={handleSubmitCode}
          disabled={loading}
          className="w-full bg-[#C00000] hover:bg-red-700 text-white py-3 rounded-md font-semibold transition"
        >
          {loading ? "Verifying..." : "VERIFY CODE"}
        </button>

        <button
          onClick={handleResendApi}
          disabled={resendLoading}
          className="w-full bg-[#A0A0A0] hover:bg-gray-400 text-black py-3 rounded-md font-semibold transition mt-3"
        >
          {resendLoading ? "Resending..." : "RESEND CODE"}
        </button>
      </div>
    </div>
  );
};

export default CodeVerificationScreen;
